import { createIcon } from './icon-utils';

export const UndoIcon = createIcon({
  path: 'M4.067 9.936h-.504a.75.75 0 0 1-.75-.75V3.561a.75.75 0 0 1 1.5 0v3.411A9.187 9.187 0 1 1 12 21.186a.75.75 0 0 1 0-1.5 7.687 7.687 0 1 0-6.808-11.25h3.995a.75.75 0 0 1 0 1.5h-5.12z',
});
